import { useMemo } from 'preact/hooks';
import { FormFieldContextProps } from '../UNSAFE_useFormFieldContext';

type UseTextFieldProps<V> = {
  hasValue?: boolean;
  isDisabled?: boolean;
  isFocused?: boolean;
  isInputFocused?: boolean;
  isLoading?: boolean;
  isReadonly?: boolean;
  value?: V;
};

/**
 * A custom hook to determine props to set FormFieldContext
 */
export function useFormFieldContextProps<V>({
  hasValue,
  isDisabled,
  isFocused,
  isInputFocused,
  isLoading,
  isReadonly,
  value
}: UseTextFieldProps<V>) {
  return useMemo<FormFieldContextProps>(() => {
    return isReadonly
      ? {
          hasValue,
          isFocused,
          isInputFocused,
          isLoading,
          isReadonly: true
        }
      : isDisabled
      ? {
          hasValue,
          isDisabled: true,
          isLoading
        }
      : {
          hasValue,
          isFocused,
          isInputFocused,
          isLoading
        };
  }, [hasValue, isDisabled, isFocused, isInputFocused, isLoading, isReadonly, value]);
}
